import axios from 'axios';

// Use an environment variable for the API base URL
const API_URL = process.env.REACT_APP_API_URL || 'https://icollectapi.huburllc.com/api/';

const api = axios.create({
  baseURL: API_URL, 
});

/**
 * Request Interceptor
 * This adds the JWT token from localStorage to the Authorization header of every
 * request sent from the frontend.
 */
api.interceptors.request.use(
  (config) => {
    // Retrieve the token from local storage
    const token = localStorage.getItem('token');
    if (token) {
      // If the token exists, add it to the Authorization header
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // Handle request errors
    return Promise.reject(error);
  }
);

export default api;
